import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { JsonDataService } from 'src/app/services/json-data.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'coic-on-demand',
    templateUrl: './coic-on-demand.component.html',
    styleUrls: ['./coic-on-demand.component.css']
})
export class CoicOnDemand implements OnInit {

    userId: string = this.userDetailService.userId;
    moduleId: string = 'BMZ010';
    moduleName = this.jsonDataService.data.moduleList
        .filter((data: any) => data.moduleId === 'BMZ010')[0]
        .moduleDesc.toUpperCase();

    constructor(
        private jsonDataService: JsonDataService,
        private userDetailService: UserDetailsService,
        private http: HttpClient
    ) {}

    datePipe = new DatePipe('en-us');

    ngOnInit(): void {}

    getRedirectUrl(): string {
        const hostname = window.location.hostname;

        if (hostname === 'admin.osp-devt.com') {
            return 'https://partners-api-v2.dev.bpimsapps.com/maintenance/redirect';
        } else if (hostname === 'admin.osp-test.com') {
            return 'https://partners-api-v2.uat.bpimsapps.com/maintenance/redirect';
        } else if (hostname === 'admin.express-protect.com') {
            return 'https://partners-api-v2.bpimsapps.com/maintenance/redirect';
        } else {
            console.error('Unknown hostname:', hostname);
            return '';
        }
    }

    buildPayload() {
        const currentDate = new Date();
        const formattedDate = this.datePipe.transform(currentDate, 'yyyy-MM-dd HH:mm:ss');

        return {
            time: formattedDate,
            name: this.userDetailService.name,
            userId: this.userDetailService.userId,
            email: this.userDetailService.email,
            moduleId: this.moduleId,
            moduleName: this.moduleName,
        };
    }

    onButtonClick(): void {
        const url = this.getRedirectUrl();
        const payload = this.buildPayload();

        if (!url) return;
        this.jsonDataService.contorlLoading(true);
        const encryptedData = this.jsonDataService.encrypt(
            JSON.stringify(payload)
        );

        this.http.post(url, JSON.stringify({ data: encryptedData}), {
            observe: 'response'
        }).subscribe({
            next: (res: any) => {

                try {
                    const encrypted = res.body?.data;

                    if (!encrypted) {
                        console.warn('No encrypted data found');
                        return;
                    }
                    const decrypted = this.jsonDataService.decrypt(encrypted);
                    // console.log('Decrypted:', decrypted);
                    const parsed = JSON.parse(decrypted);
                    // console.log('Parsed:', parsed);
                    this.jsonDataService.contorlLoading(false);
                    if (parsed?.redirectUrl) {
                        window.open(parsed.redirectUrl, '_blank');
                    }

                } catch (err) {
                    console.error('Decryption/Parsing error:', err);
                }
            },
            error: (err) => {
                console.error('Redirect error:', err);
            }
        });
    }
}
